import React from "react";
import { MarketData } from "@iliotech/watchlist-api/src/types/MarketData";
import { MarketInsightsColumns } from "../../../../../insights/MarketLevel/MarketInsightDiscoveryTable/marketInsightDiscoveryTableColumns";
import { SingleItemMarketInsightTable } from "./SingleItemMarketInsightTable";
import { WatchlistBreakdown } from "@iliotech/watchlist-api";

interface MarketInsightSingleItemTableProps {
  data: Partial<MarketData>;
  sortedItems: WatchlistBreakdown[];
  category: string;
}

export const MarketInsightSingleItemTable: React.FC<MarketInsightSingleItemTableProps> =
  ({ data, sortedItems, category }) => {
    const rankedData = React.useMemo(() => {
      return [{ ...data, ranking: 1 }];
    }, [data]);

    const columns = React.useMemo(() => {
      if (!data) {
        return [];
      }
      const allFields = Object.keys(data).filter(
        (item) =>
          item !== "Ranking" &&
          item !== "instrumentId" &&
          item !== "label" &&
          item !== "icon" &&
          item !== "name"
      );

      const toRet = MarketInsightsColumns(
        allFields,
        () => {}, // No-op for onInstrumentClick
        () => category, // Always return the fixed categoryId
        () => true // Show all columns
      ).filter((item) => item.field !== "Ranking");

      return toRet.sort((a, b) => (a.order || 900) - (b.order || 900));
    }, [data]);

    return (
      <SingleItemMarketInsightTable
        sortedItems={sortedItems} // Empty array since we don't need sorting functionality
        activeColumns={columns}
        data={rankedData}
      />
    );
  };

export default MarketInsightSingleItemTable;
